import { useState } from 'react';
import { Checkbox, Pressable, Row, Text } from '~/commonComponents';
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { Links } from '~/constants';
import { Colors } from '~/themes/colors';

interface IAchAuthorizationPopupProps {
  onConfirm: () => void;
}

export function AchAuthorizationPopup({ onConfirm }: IAchAuthorizationPopupProps) {
  const [isChecked, setIsChecked] = useState(false);

  const toggleChecked = () => setIsChecked((prev) => !prev);

  const handleConfirm = () => {
    onConfirm();
    setIsChecked(false);
  };

  return (
    // @ts-expect-error ConfirmPopup is a JS file
    <ConfirmPopup
      dismissiblePopup={false}
      title="ACH Authorization Mandate"
      rightButtonText="Confirm"
      rightButtonDisabled={!isChecked}
      rightButtonAction={handleConfirm}
      dataTestId="ach-authorization-popup"
      dataCy="ach-authorization-popup"
      rightButtonDataCy="ach-confirm-button"
    >
      <Row marginBottom={32} paddingHorizontal={20} width={400} gap={12} alignItems="flex-start">
        <Pressable onPress={toggleChecked}>
          <Checkbox checked={isChecked} style={{ marginTop: 3 }} />
        </Pressable>
        <Text color="neutral_500" textAlign="left">
          I authorize GoTu to electronically debit my account and, if necessary, electronically
          credit my account to correct erroneous debits. For full details, review GoTu&apos;s{' '}
          <a
            href={Links.termsOfUse}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: Colors.secondary_500,
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            Terms of Service
          </a>
          .
        </Text>
      </Row>
    </ConfirmPopup>
  );
}
